<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="图片连接">
              <a-input placeholder="请输入图片连接" v-model="queryParam.imageUrl"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="日期">
              <a-input placeholder="请输入日期" v-model="queryParam.imageDate"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('每日日签')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange">


        <template slot="imageUrl" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无图片</span>
          <img
            v-else
            :src="getImgView(text)"
            @click="showImgDialog(getImgView(text))"
            height="160px"
            alt
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="imageUrl2" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无图片</span>
          <img
            v-else
            :src="getImgView(text)"
            @click="showImgDialog(getImgView(text))"
            height="160px"
            alt
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <a-modal
      hoverable
      title="查看照片"
      :visible="imgboxModal"
      centered
      @cancel="() => ((imgModelSrc = ''), (imgboxModal = false))"
      width="50%"
      :footer="null"
    >
      <img :src="imgModelSrc" alt style="width: 100%" />
    </a-modal>
    <!-- 表单区域 -->
    <dailyImage-modal ref="modalForm" @ok="modalFormOk"></dailyImage-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import DailyImageModal from './modules/DailyImageModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

export default {
  name: "DailyImageList",
  mixins: [JeecgListMixin],
  components: {
    DailyImageModal
  },
  data() {
    return {
      description: '每日日签管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: "center",
          customRender: function (t, r, index) {
            return parseInt(index) + 1;
          }
        },
        {
          title: '图片',
          align: "center",
          dataIndex: 'imageUrl',
          scopedSlots: { customRender: 'imageUrl' },
        },
        {
          title: '图片-带二维码',
          align: "center",
          dataIndex: 'imageUrl2',
          scopedSlots: { customRender: 'imageUrl2' },
        },
        {
          title: '日期',
          align: "center",
          dataIndex: 'imageDate'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: "center",
          scopedSlots: { customRender: 'action' },
        }
      ],
      url: {
        list: "/dailyImage/list",
        delete: "/dailyImage/delete",
        deleteBatch: "/dailyImage/deleteBatch",
        exportXlsUrl: "/dailyImage/exportXls",
        importExcelUrl: "/dailyImage/importExcel",
      },
      imgModelSrc: '',
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    }
  },
  methods: {
    showImgDialog(src) {
      console.log(src)
      this.imgboxModal = true
      this.imgModelSrc = src
    },
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>